import { enableProdMode, Injector, LOCALE_ID, DEFAULT_CURRENCY_CODE, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { environment } from './environments/environment';
import {
    getRemoteServiceBaseUrl,
    appInitializerFactory,
    getCurrencyCode,
    getCurrentLanguage,
} from './root.module';
import { LicenseManager } from 'ag-grid-enterprise';
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';
import { PlatformLocation } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AM_API_BASE_URL } from '@app/modules/account-mapping/account-mapping-proxies';
import { CL_API_BASE_URL } from '@app/modules/checklists/checklists-proxies';
import { DAC6_API_BASE_URL } from '@app/modules/dac6/dac6-proxies';
import { GEN_API_BASE_URL } from '@shared/service-proxies/general-proxies';
import { MDM_API_BASE_URL } from '@app/modules/master-data-management/master-data-management-proxies';
import { P2_API_BASE_URL } from '@app/modules/pillar2/pillar2-proxies';
import { RPT_API_BASE_URL } from '@app/modules/real-property-tax/real-property-tax-proxies';
import { TA_API_BASE_URL } from '@app/modules/tax-analytics/tax-analytics-proxies';
import { IRO_API_BASE_URL } from '@app/modules/iro/iro-proxies';
import { TA_API_BASE_URL as TAI_API_BASE_URL } from '@app/modules/tax-ai/tax-ai-proxies';
import { VID_API_BASE_URL } from '@app/modules/vat/vat-proxies';
import { HMRC_API_BASE_URL } from '@app/modules/hmrc/hmrc-proxies';
import { GlobalErrorHandler } from 'global-error-handler.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppModule } from './app/app.module';
import { MazarsPortalCommonModule } from '@shared/common/common.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { RootRoutingModule } from './root-routing.module';
import { RootComponent } from './root.component';
import { providePrimeNG } from 'primeng/config';
import Mazars from './shared/themes/mazars';


LicenseManager.setLicenseKey(
    'Using_this_AG_Grid_Enterprise_key_( AG-046852 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Mazars GmbH & Co. KG )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Digital Tax Portal )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( Digital Tax Portal )_need_to_be_licensed___( Digital Tax Portal )_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 19 October 2024 )____[v2]_MTcyOTI5MjQwMDAwMA==e442f824a9467703f0fa2781ebac2cb3',
);

if (environment.production) {
    enableProdMode();
}

const bootstrap = () =>
    bootstrapApplication(RootComponent, {
        providers: [
            importProvidersFrom(BrowserModule, AppModule, MazarsPortalCommonModule.forRoot(), ServiceProxyModule, RootRoutingModule, NgxSpinnerModule),
            { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: AM_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: CL_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: DAC6_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: GEN_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: MDM_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: P2_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: RPT_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: TA_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: IRO_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: TAI_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: VID_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            { provide: HMRC_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
            provideAppInitializer(() => {
                const initializerFn = appInitializerFactory(inject(Injector), inject(PlatformLocation));
                return initializerFn();
            }),
            {
                provide: LOCALE_ID,
                useFactory: getCurrentLanguage,
            },
            {
                provide: DEFAULT_CURRENCY_CODE,
                useFactory: getCurrencyCode,
                deps: [Injector],
            },
            { provide: ErrorHandler, useClass: GlobalErrorHandler },
            provideAnimations(),
            provideHttpClient(withInterceptorsFromDi()),
            providePrimeNG({
                theme: {
                    preset: Mazars,
                    options: {
                        darkModeSelector: false || 'none',
                    },
                },
            }),
        ],
    });

bootstrap(); //Regular bootstrap
